<template>
  <DBox
    :id="'cmp-booking-venues-venue_sidewindow-related_contacts'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('contact_relation')}`"
    @addClick="addContactRelationClick"
  >
    <NTable
      :v-if="
        venue && venue.contact_relations && venue.contact_relations.length > 0
      "
      :items="venue.contact_relations"
      :headers="headers"
      :config="tableConfig"
      id="booking-venues-venue_sidewindow-related_contacts"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('relation')">
            <input
              type="text"
              class="dbox-table--textfield"
              name="relation"
              id="relation"
              :placeholder="$t('relation')"
              :value="item['relation']"
              v-on:blur="e => onTextInputBlur(e, 'relation', item)"
            />
          </td>
          <td v-bind="tdcon('artist')" @click="e => onArtistNameClick(item)">
            {{ item["contact_name"] }}
          </td>
          <td v-bind="tdcon('phone1')">
            {{ item["phone1"] }}
          </td>
          <td v-bind="tdcon('mail')">
            <div class="dt-icon-container">
              <img
                v-if="item['email1']"
                src="static/icons/email/email-grey.svg"
                class="dt-icon v5 s1"
                @click="e => onMail(item)"
                alt=""
              />
            </div>
          </td>
          <td v-bind="tdcon('delete')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="e => onDeleteRelatedContact(item)"
                alt=""
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";

import { openMailWindow } from "../../../../utility";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import NTable from "@/plugins/datatable/datatable";

export default {
  components: {
    DBox,
    NTable
  },
  props: {
    venue: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 2,
        fullHeight: true,
        footer: false,
        showHeader: false
      })
    };
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("relation"),
        createTableHeader("artist"),
        createTableHeader("phone1"),
        createTableHeader("mail", { mw: 35 }),
        createTableHeader("delete", { mw: 35 })
      ];
    }
  },
  methods: {
    onTextInputBlur: function(event, name, item) {
      const value = event.target.value;
      this.$emit("changed", { name, value, item });
    },
    onCheckboxChange: function(event, name, item) {
      // const checked = event.target.checked;
      // const value = checked === true ? "1" : "0";
      // if (name === 'main_contact_id') {
      //   this[ActionTypes.SELECTED_ARTIST.UPDATE.SINGLE]({
      //     item: this.selectedArtist,
      //     name,
      //     value: item.contact_id
      //   });
      // } else {
      //   this[ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE]({ item, name, value});
      // }
    },
    onArtistNameClick: function(artist) {
      this.$emit(
        "artist_calendar_date_selected",
        artist.calendar_date_artist_id
      );
    },
    addArtistClick: function() {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: "add_artist"
        }
      });
    },
    onMail: function(contact) {
      openMailWindow(`mailto: ${contact.email1}`);
      // location.href = ;
    },
    addContactRelationClick: function() {
      // console.log(this.venue.location);
      const bookingLocationId = this.venue.location.booking_location_id;
      // console.log(bookingLocationId);
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact_relation",
          external_id: bookingLocationId,
          external_table: "booking_locations"
        }
      });
    },
    onDeleteRelatedContact: function(contact) {
      // this[ActionTypes.RELATED_CONTACTS.DELETE.SINGLE]({
      //   contactRelationId: contact.contact_relation_id
      // });
      this.$emit("delete", contact);
    }

    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-booking-venues-venue_sidewindow-related_contacts {
}
</style>
